export const translations = {
  // Common
  home: 'الرئيسية',
  shop: 'المتجر',
  about: 'من نحن',
  contact: 'اتصل بنا',
  cart: 'السلة',
  language: 'اللغة',
  currency: 'ج.م',
  
  // Announcement
  welcomeMessage: 'مرحباً بك في شركة محمد حسن أمين',
  freeShipping: 'شحن مجاني للطلبات المؤهلة',
  
  // Products
  ourProducts: 'منتجاتنا',
  discoverProducts: 'اكتشف مجموعتنا الواسعة من المنتجات عالية الجودة',
  searchProducts: '...ابحث عن منتج',
  allCategories: 'جميع الفئات',
  allBrands: 'جميع الماركات',
  showing: 'عرض',
  showingResults: 'عرض',
  noProductsFound: 'لم يتم العثور على منتجات',
  previous: 'السابق',
  next: 'التالي',
  of: 'من',
  products: 'منتجات',
  product: 'منتج',
  addToCart: 'أضف للسلة',
  viewCart: 'عرض السلة',
  inStock: 'متوفر',
  outOfStock: 'غير متوفر',
  quickView: 'عرض سريع',
  wishlist: 'المفضلة',
  noImage: 'لا توجد صورة',
  sortBy: 'ترتيب حسب',
  defaultSort: 'افتراضي',
  priceLowToHigh: 'السعر: من الأقل للأعلى',
  priceHighToLow: 'السعر: من الأعلى للأقل',
  onSale: 'عروض',
  filters: 'خيارات البحث',
  allProducts: 'جميع المنتجات',
  discountedOnly: 'المخفضة فقط',
  
  // Cart
  shoppingCart: 'سلة التسوق',
  reviewItems: 'راجع العناصر الخاصة بك وانتقل إلى الدفع',
  yourCartEmpty: 'سلة التسوق فارغة',
  continueShopping: 'متابعة التسوق',
  clearCart: 'مسح السلة',
  cartSummary: 'ملخص السلة',
  items: 'العناصر',
  total: 'الإجمالي',
  unitPrice: 'سعر الوحدة',
  quantity: 'الكمية',
  subtotal: 'المجموع الفرعي',
  shipping: 'الشحن',
  discount: 'الخصم',
  tax: 'الضريبة',
  free: 'مجاني',
  city: 'المدينة',
  selectCity: 'اختر المدينة',
  promoCode: 'كود الخصم',
  enterPromoCode: 'أدخل كود الخصم',
  apply: 'تطبيق',
  promoCodeApplied: 'تم تطبيق كود الخصم!',
  offApplied: 'تم التطبيق!',
  paymentMethod: 'طريقة الدفع',
  cardPayment: 'فيزا / ماستركارد / أبل باي',
  cashOnDelivery: 'الدفع عند الاستلام / إنستاباي',
  instapayCashOnDelivery: 'إنستاباي / الدفع عند الاستلام',
  visaApplePay: 'فيزا / أبل باي',
  visa: 'فيزا',
  securedByPaymob: 'مؤمّن بواسطة Paymob',
  applePay: 'أبل باي',
  cash: 'كاش',
  instapay: 'إنستاباي',
  placeOrder: 'تأكيد الطلب',
  remove: 'إزالة',
  proceedToCheckout: 'المتابعة إلى الدفع',
  
  // Checkout
  checkout: 'الدفع',
  completeOrder: 'أكمل تفاصيل طلبك',
  shippingInformation: 'معلومات الشحن',
  fullName: 'الاسم الكامل',
  email: 'البريد الإلكتروني',
  phone: 'الهاتف',
  phoneNumberLabel: 'رقم الهاتف',
  shippingAddress: 'عنوان الشحن',
  enterFullName: 'أدخل اسمك الكامل',
  enterEmail: 'أدخل بريدك الإلكتروني',
  enterPhone: 'أدخل رقم هاتفك',
  enterShippingAddress: 'أدخل عنوان الشحن',
  proceedToPayment: 'المتابعة إلى الدفع',
  processing: 'جاري المعالجة...',
  orderSummary: 'ملخص الطلب',
  
  // Payment
  paymentSuccessful: 'تم الدفع بنجاح!',
  orderSuccessful: 'تم الطلب بنجاح!',
  paymentFailed: 'فشل الدفع',
  paymentPending: 'الدفع معلق',
  thankYouOrder: 'شكراً لطلبك. تم معالجة الدفع بنجاح.',
  paymentNotProcessed: 'للأسف، لم يتم معالجة الدفع. يرجى المحاولة مرة أخرى.',
  paymentProcessing: 'يرجى الانتظار أثناء معالجة الدفع...',
  processingPayment: 'جاري معالجة الدفع...',
  orderDetails: 'تفاصيل الطلب',
  orderNumber: 'رقم الطلب',
  totalAmount: 'المبلغ الإجمالي',
  status: 'الحالة',
  orderShipped: 'سيتم الشحن خلال 3 أيام',
  backToCart: 'العودة إلى السلة',
  orderConfirmed: 'تم تأكيد طلبك وسيتم معالجته قريباً.',
  printOrder: 'تحميل الطلب',
  
  // Footer
  designedBy: 'صمم وأنشأ بواسطة',
  taxNumber: 'الرقم الضريبي: ٢٣٢٤٤٦٧٦٨',
  copyright: 'حقوق النشر',
  allRightsReserved: 'جميع الحقوق محفوظة',
  websiteDesignedBy: 'الموقع صمم وأنشأ بواسطة',
  
  // Info Popup
  contactUs: 'اتصل بنا',
  address: 'العنوان',
  companyAddress: '٩ شارع عبد الحق السنباطي، ميدان الأوبرا',
  companyCityCountry: 'القاهرة - مصر',
  phoneNumber: '+20 12 29009073',
  emailAddress: 'mohamedhassanamin.co@gmail.com',
  
  // Contact Page
  contactSubtitle: 'تواصل معنا',
  ourAddress: 'عنواننا',
  location: 'الموقع',
  getInTouch: 'تواصل معنا',
  yourName: 'اسمك',
  yourEmail: 'بريدك الإلكتروني',
  yourPhone: 'رقم هاتفك',
  subject: 'الموضوع',
  yourMessage: 'رسالتك',
  sendMessage: 'إرسال الرسالة',
  contactFormSuccess: 'شكراً لرسالتك! سنتواصل معك قريباً.',
  findUs: 'اعثر علينا',
  viewOnMap: 'شاهد موقعنا على خرائط جوجل',
  openInGoogleMaps: 'افتح في خرائط جوجل',
  
  // About Page
  aboutUs: 'من نحن',
  aboutSubtitle: 'تعرف على المزيد عن شركتنا',
  welcomeToCompany: 'مرحباً بك في',
  companyName: 'شركة محمد حسن أمين',
  companyFullName: 'شركة محمد حسن أمين',
  aboutDescription1: 'شركة محمد حسن أمين هي مزود رائد للمنتجات والخدمات عالية الجودة. نحن ملتزمون بتقديم التميز وبناء علاقات دائمة مع عملائنا.',
  aboutDescription2: 'مع سنوات من الخبرة في الصناعة، أصبحنا شريكاً موثوقاً للشركات والأفراد الذين يبحثون عن حلول عالية الجودة. فريقنا مخصص لتقديم خدمة ودعم استثنائيين.',
  companyProfile: 'الملف التعريفي للشركة',
  downloadProfile: 'تحميل الملف التعريفي للشركة',
  companyProfileDescription: 'قم بتنزيل الملف التعريفي الشامل للشركة للتعرف على تاريخنا ورسالتنا وقيمنا والمنتجات والخدمات عالية الجودة التي نقدمها.',
  installApp: 'تحميل التطبيق',
  installAppTitle: 'حمّل تطبيقنا',
  installAppDesc: 'حمّل تطبيقنا للوصول الأسرع، التصفح بدون إنترنت، وإشعارات فورية بأحدث العروض والمنتجات.',
  installAppBtn: 'تحميل التطبيق',
  installAppIosStep1: 'اضغط على زر المشاركة أسفل الشاشة',
  installAppIosStep2: 'اضغط على "إضافة إلى الشاشة الرئيسية"',
  installAppIosLabel: 'للتثبيت على الآيفون:',
  estIn1972: 'تأسست في ١٩٧٢',
  shopNow: 'تسوق الآن',
  bestProduct: 'أفضل منتج',
  bestQuality: 'منتجات بأفضل جودة',
  fastDelivery: 'توصيل سريع',
  fastDeliveryDesc: 'شحن سريع وموثوق',
  securePayment: 'دفع آمن',
  securePaymentDesc: 'معاملات آمنة ومضمونة',
  customerSupport: 'دعم على مدار الساعة',
  customerSupportDesc: 'نحن هنا دائماً للمساعدة',
  
  // Categories
  ourCategories: 'فئاتنا',
  discoverCategories: 'استكشف فئات منتجاتنا',
  
  // Brands
  ourBrands: 'ماركاتنا',
  browseBrands: 'تصفح المنتجات حسب الماركة',
  
  // Latest News
  latestNews: 'آخر الأخبار',
  stayUpdated: 'ابق على اطلاع بآخر التحديثات والإعلانات',
  
  // Product Detail
  productCatalog: 'كتالوج المنتج',
  downloadCatalog: 'تحميل الكتالوج',
  downloadPdf: 'تحميل PDF',
  
  // Errors
  errorOccurred: 'حدث خطأ',
  tryAgain: 'يرجى المحاولة مرة أخرى لاحقاً',
  
  // Toast Messages
  productAddedToCart: 'تمت الإضافة إلى السلة!',
  selectAllRequiredOptions: 'يرجى اختيار جميع الخيارات المطلوبة',
  productSavedSuccessfully: 'تم حفظ المنتج بنجاح!',
  optionAddedSuccessfully: 'تمت إضافة الخيار بنجاح',
  optionDeletedSuccessfully: 'تم حذف الخيار بنجاح',
  valueAddedSuccessfully: 'تمت إضافة القيمة بنجاح',
  valueDeletedSuccessfully: 'تم حذف القيمة بنجاح',
  markedAsReadSuccessfully: 'تم وضع علامة كمقروء بنجاح',
  submissionDeletedSuccessfully: 'تم حذف الرسالة بنجاح',
  orderMarkedAsRead: 'تم وضع علامة على الطلب كمقروء',
  deliveredStatusUpdated: 'تم تحديث حالة التسليم',
  statusSetToSuccess: ' وتم تعيين الحالة إلى نجاح',
  statusUpdatedSuccessfully: 'تم تحديث الحالة بنجاح',
  paymentMethodUpdated: 'تم تحديث طريقة الدفع',
  orderStatusUpdatedSuccessfully: 'تم تحديث حالة الطلب بنجاح',
  contactSettingsSavedSuccessfully: 'تم حفظ إعدادات الاتصال بنجاح',
  failedToLoad: 'فشل التحميل',
  failedToSave: 'فشل الحفظ',
  failedToDelete: 'فشل الحذف',
  failedToUpdate: 'فشل التحديث',
  pleaseSaveProductFirst: 'يرجى حفظ المنتج أولاً قبل إضافة الخيارات',
  errorProcessingCheckout: 'خطأ في معالجة الدفع',

  // App update banner (PWA)
  updateAvailable: 'يتوفر تحديث جديد',
  updateAvailableDesc: 'إصدار جديد من المتجر جاهز. حدّث الصفحة وقتما تشاء.',
  refresh: 'تحديث',
  updating: 'جارٍ التحديث...',
  later: 'لاحقاً',

  // Not found states
  pageNotFoundTitle: 'الصفحة غير موجودة',
  pageNotFoundDesc: 'الصفحة التي تبحث عنها غير موجودة أو تم نقلها.',
  backToHome: 'العودة إلى الرئيسية',
  browseProducts: 'تصفح المنتجات',
  productNotFound: 'المنتج غير موجود',
  productNotFoundDesc: 'هذا المنتج غير متاح أو لم يعد موجوداً.',

  // Loading / stock
  loading: 'جارٍ التحميل...',
  onlyNAvailable: 'المتاح في المخزون {n} فقط',
  freeShippingGeneric: 'شحن مجاني للطلبات المؤهلة',
  freeShippingOverAmount: 'شحن مجاني للطلبات أكثر من {amount} جنيه',

  // Instapay instructions on the order success page (stream A handoff)
  instapayInstructionsTitle: 'الدفع عبر إنستاباي',
  instapayInstructions: 'سنتواصل معك على رقم هاتفك أو بريدك الإلكتروني ببيانات التحويل. يرجى كتابة رقم الطلب في ملاحظة التحويل. سيتم تأكيد الطلب بعد استلام المبلغ.',

  // Contact form validation
  nameTooShort: 'يجب أن يتكون الاسم من حرفين على الأقل.',
  invalidEmail: 'يرجى إدخال بريد إلكتروني صحيح.',
  invalidPhone: 'يرجى إدخال رقم هاتف صحيح.',
  messageTooShort: 'يجب أن تتكون الرسالة من 10 أحرف على الأقل.',
  contactFormFailed: 'فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.',
  connectionError: 'تعذر الاتصال بالخادم. يرجى التحقق من اتصالك والمحاولة مرة أخرى.',
};
